import { render } from "./direct_sale.vue?vue&type=template&id=fd736148&scoped=true"
import script from "./direct_sale.vue?vue&type=script&lang=js"
export * from "./direct_sale.vue?vue&type=script&lang=js"

import "./direct_sale.vue?vue&type=style&index=0&id=fd736148&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd736148"]])

export default __exports__